import {
  FETCH_MARKET_FEATURE_FLAGS,
  UPDATE_FEATURE_FLAGS,
  FEATURE_FLAGS_LOADING,
} from '../actions/featureFlags';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_MARKET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.payload,
      };
    case FEATURE_FLAGS_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case UPDATE_FEATURE_FLAGS:
    default:
      return state;
  }
}
